import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';

import { TranslocoModule } from '@ngneat/transloco';

import { CookieConsentService } from '../../services/cookie-consent.service';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  imports: [CommonModule, TranslocoModule, ButtonModule, DialogModule],
})
export class CookieBannerComponent implements OnInit {
  private cookieConsentService = inject(CookieConsentService);

  showBanner = false;
  showPolicyDialog = false;

  ngOnInit(): void {
    this.showBanner = !this.cookieConsentService.hasConsent();
  }

  acceptCookies(): void {
    this.cookieConsentService.giveConsent();
    this.showBanner = false;
  }

  showCookiePolicy(): void {
    this.showPolicyDialog = true;
  }
}
